import React, { useEffect, useState } from "react";
import { Alert, Box, Button, CircularProgress, Paper, Stack, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import { authService } from "../services/resources.service";
import { storeSessionToken } from "../services/authSession";
import { useMessage } from "../i18n/locale";

const activationRequests = new Map();

function activateOnce(token) {
  if (!activationRequests.has(token)) {
    activationRequests.set(token, authService.activate(token));
  }
  return activationRequests.get(token);
}

export default function ActivateAccount({ onAuth }) {
  const token = new URLSearchParams(useLocation().search).get("token");
  const [status, setStatus] = useState(token ? "loading" : "error");
  const [error, setError] = useState("");
  const title = useMessage("activationTitle");
  const activating = useMessage("activationWorking");
  const success = useMessage("activationSuccess");
  const invalid = useMessage("activationInvalid");
  const continueLabel = useMessage("activationContinue");
  const signIn = useMessage("authSignIn");

  useEffect(() => {
    if (!token) {
      setError(invalid);
      return undefined;
    }
    let active = true;
    activateOnce(token).then((result) => {
      if (!active) return;
      storeSessionToken(result.token);
      onAuth?.(result.user);
      setStatus("success");
    }).catch((requestError) => {
      if (!active) return;
      setError(requestError.message || invalid);
      setStatus("error");
    });
    return () => { active = false; };
  }, [invalid, onAuth, token]);

  return (
    <Box sx={{ minHeight: "100dvh", display: "grid", placeItems: "center", p: 2 }}>
      <Paper elevation={0} sx={{ width: "100%", maxWidth: 440, p: 3, border: 1, borderColor: "divider", borderRadius: 3 }}>
        <Stack spacing={2} alignItems="center" textAlign="center">
          <Typography variant="h5" fontWeight={900}>{title}</Typography>
          {status === "loading" && <><CircularProgress /><Typography>{activating}</Typography></>}
          {status === "success" && <Alert severity="success">{success}</Alert>}
          {status === "error" && <Alert severity="error">{error || invalid}</Alert>}
          {status === "success" && <Button component={Link} to="/me" variant="contained">{continueLabel}</Button>}
          {status === "error" && <Button component={Link} to="/auth" variant="outlined">{signIn}</Button>}
        </Stack>
      </Paper>
    </Box>
  );
}
